export default {
  country: 'Paese',
  language: 'Lingua',
  currency: 'Valuta',
}
